import React, { useState, useEffect } from 'react'
import { BaseAsset, Status } from 'types/Response'

import DallE3Finish from 'components/DallE3Finish'

interface FinishStageProps {
  text?: string
  currentAssetUrl?: string | undefined
  currentAssetIndex: number
  assets?: BaseAsset[]
  sharedSlides: number[]
  setSharedSlides: React.Dispatch<React.SetStateAction<number[]>>
  onGenerateMore: () => void
  onGoBack: () => void
  isLoading: boolean
  onTextChange: (newText: string) => void
  generationStatus: Status
}

function FinishStage({
  text = '',
  currentAssetUrl = undefined,
  isLoading,
  currentAssetIndex,
  assets = [],
  sharedSlides,
  setSharedSlides,
  onGenerateMore,
  onGoBack,
  onTextChange,
  generationStatus,
}: FinishStageProps) {
  const [firstProcessedAssetIndex, setFirstProcessedAssetIndex] = useState<
    number | undefined
  >(undefined)

  useEffect(() => {
    if (firstProcessedAssetIndex) return
    const processedAsset = assets?.findIndex((a) => a.url)
    if (processedAsset) {
      setFirstProcessedAssetIndex(processedAsset)
    }
  }, [assets])

  return (
    <DallE3Finish
      isLoading={isLoading}
      currentAssetIndex={currentAssetIndex}
      onGenerateMore={onGenerateMore}
      onGoBack={onGoBack}
      sharedSlides={sharedSlides}
      assets={assets}
      onTextChange={onTextChange}
      setSharedSlides={setSharedSlides}
      text={text}
      generationStatus={generationStatus}
    />
  )
}

export default FinishStage
